import constants from '../../../../constants.json';
import { Modal } from '../../../Modal/Modal';
import ChatBubbleIcon from '../../../svg/ChatBubbleIcon.svg?react';
import EnvelopeIcon from '../../../svg/EnvelopeIcon.svg?react';
import FaqIcon from '../../../svg/FaqIcon.svg?react';
import HelpIcon from '../../../svg/HelpIcon.svg?react';
import PhoneIcon from '../../../svg/PhoneIcon.svg?react';

export const HelpModal = ({
  isOpen,
  closeModal,
}: {
  isOpen: boolean;
  closeModal: () => void;
}) => {
  return (
    <Modal
      isModalOpen={isOpen}
      closeModal={closeModal}
      isClosable={true}
      testPrefix="helpModal"
    >
      <>
        <div
          className="flex h-[50px] justify-center pb-[30px] text-[24px] font-med"
          data-testid="help-modal"
        >
          <div className="flex h-full items-end">
            <span>Need help?</span>
          </div>
          <div className="flex h-full items-start">
            <HelpIcon className="mb-[45px]" />
          </div>
        </div>
        <div className="px-[20px] min-m:mb-[60px] min-m:px-[40px]">
          <div className="flex items-center border-b border-solid border-structure-95 pb-[23px]">
            <div>
              <div className="mb-[15px] flex items-center">
                <PhoneIcon className="mr-[20px] h-[25px] min-h-[25px] w-[25px] min-w-[25px] fill-coral-65" />
                <div className="flex flex-col min-m:block">
                  <span>Call us at</span>
                  &nbsp;
                  <a
                    href={constants.iwocapayTelLink}
                    className="font-med text-denim-45"
                  >
                    <span>{constants.iwocapayTelDisplay}</span>
                  </a>
                </div>
              </div>
              <div className="mb-0 flex items-center">
                <ChatBubbleIcon className="mr-[20px] h-[25px] min-h-[25px] w-[25px] min-w-[25px] fill-coral-65" />
                <div>
                  <span>You can also</span>
                  &nbsp;
                  <button
                    onClick={closeModal}
                    className="cursor-pointer border-0 bg-white p-0 font-med text-denim-45 underline"
                  >
                    <span>Chat to us!</span>
                  </button>
                </div>
              </div>
            </div>
            <span className="mx-[15px] h-[90px] border border-solid border-structure-95 min-m:mx-[20px]" />
            <div className="flex flex-col text-[12px] min-m:text-[16px]">
              <span>Monday to Friday</span>
              <span>9am &ndash; 6pm</span>
              <span className="text-[12px] font-reg min-m:text-[14px]">
                (excluding bank holidays)
              </span>
            </div>
          </div>
          <div className="mt-[40px]">
            <div className="mb-[15px] flex items-center">
              <EnvelopeIcon className="mr-[20px] h-[25px] min-h-[25px] w-[25px] min-w-[25px] fill-coral-65" />
              <div>
                <span>Email at</span>
                &nbsp;
                <a
                  href={constants.contactUsEmailLink}
                  className="font-med text-denim-45"
                >
                  <span>{constants.contactUsEmailDisplay}</span>
                </a>
              </div>
            </div>
            <div className="flex">
              <FaqIcon className="mr-[20px] h-[25px] min-h-[25px] w-[25px] min-w-[25px] fill-coral-65" />
              <div>
                <span>Find answers to common questions in our</span>
                &nbsp;
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://support.iwoca.co.uk/en/collections/2145896-what-s-iwocapay"
                  className="font-med text-denim-45"
                >
                  <span>FAQs</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </>
    </Modal>
  );
};
